import React from 'react';

import {
	ArrowLeft,
	ArrowRight,
	Container,
	StyledSlider,
} from './styled';

import { SvgIcon } from '../svg-icon'


interface Props {
	disabled:boolean,
  defaultValue:number,
  options:number[],
	onChange:(i:any)=>void,
	tooltipVisible:boolean
}

export default class extends React.Component<Props> {
	constructor(props:Props) {
		super(props);

		this.formatter = this.formatter.bind(this);
		this.increment = this.increment.bind(this);
		this.decrement = this.decrement.bind(this);
		this.getSliderMarks = this.getSliderMarks.bind(this);
	}

	getSliderMarks = (options:number[]) => ({
    min: options[0],
    max: options.slice(-1)[0],
    step: null,
    marks: options.reduce((acc, i) => ({ ...acc, [i]: <span/> }), {}),
  });

	formatter = (value:number) => (this.props.options.length > 0) ? `${value} mm` : null;

	increment = () => {
		const { defaultValue, options, onChange } = this.props;
		return options.indexOf(defaultValue) < options.length - 1
		  ? onChange(options[options.indexOf(defaultValue) + 1])
			: onChange(defaultValue)
	};

	decrement = () => {
		const { defaultValue, options, onChange } = this.props;
		return options.indexOf(defaultValue) > 0
			? onChange(options[options.indexOf(defaultValue) - 1])
			: onChange(defaultValue)
	};

  render() {
    const {
    	disabled,
      defaultValue,
      options,
			onChange,
			tooltipVisible
		} = this.props;
		
    return (
      <Container
				disabled={disabled}
			>
        <ArrowLeft
					type="arrowLeft"
					disabled={disabled}
					onClick={() => this.decrement()}
				/>
        <StyledSlider
					disabled={disabled}
					value={defaultValue}
          defaultValue={defaultValue}
          onChange={onChange}
          tipFormatter={this.formatter}
          tooltipPlacement="top"
          {...{...this.getSliderMarks(options)}}
					included={true}
          tooltipVisible={tooltipVisible}
        />
        <ArrowRight
          type="arrowLeft"
					disabled={disabled}
					onClick={() => this.increment()}
        />
      </Container>
    )
  }
};
